export type ComparativaRow = {
  before: string
  after: string
}

/** Sección 11 — Transformación */
export const transformacion: ComparativaRow[] = [
  {
    before: 'Cotizas "a ojo" y te regatean en cada reunión',
    after: 'Estructura de costos, fee blindado y propuesta profesional',
  },
  {
    before: 'Todo vive en notas del celular y mil chats',
    after: 'Brief, checklists y cronograma técnico: todo documentado',
  },
  {
    before: 'Te acuestas repasando mentalmente qué se te pudo pasar',
    after: 'Un minuto a minuto que puedes seguir con los ojos cerrados',
  },
  {
    before: 'Los proveedores te tratan como "la chica de la deco"',
    after: 'Un dream team validado que sigue tu dirección',
  },
  {
    before: 'Terminas el evento y no pasa nada más',
    after: 'Cada fiesta genera recomendaciones y tres clientas nuevas',
  },
  {
    before: 'Talento suelto',
    after: 'Directora del evento: autoridad, estatus y precio premium',
  },
]

/** Sección 15 — Costo de inacción */
export const costoDeInaccion: ComparativaRow[] = [
  {
    before: 'Cotizar "a ojo" en cada fiesta',
    after: 'Entre 200 y 800 USD que dejas sobre la mesa por evento',
  },
  {
    before: 'Rehacer checklists, cronogramas y mensajes desde cero',
    after: 'Más de 100 horas al año que nadie te paga',
  },
  {
    before: 'Un detalle olvidado el día del evento',
    after: 'Tu reputación, en un rubro que vive de la recomendación',
  },
  {
    before: 'Reservar un salón sin revisar potencia, cocina ni accesos',
    after: 'Un solo error de locación cuesta más que todo este sistema',
  },
  {
    before: 'Proveedores sin validar y sin contrato',
    after: 'Cuando uno falla, la irresponsable eres tú',
  },
]

/** Sección 16 — Cierre */
export const cierreComparativa: ComparativaRow[] = [
  {
    before: 'Improvisar cada fiesta y cruzar los dedos',
    after: 'Ejecutar un sistema probado, minuto a minuto',
  },
  {
    before: 'Cobrar poco, trabajar el doble, terminar agotada',
    after: 'Cobrar como profesional y entregar como marca premium',
  },
  {
    before: 'Empezar de cero con cada clienta',
    after: 'Abrir el tomo. Seguir el sistema. Listo.',
  },
]
